/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ============================================================
  // Sticky header on scroll up only
  // ============================================================
  let lastScroll = 0;
  const header = document.querySelector('[data-header-wrapper]');
  
  if (header && header.hasAttribute('data-header-sticky')) {
    const headerHeight = header.offsetHeight;
    
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll <= headerHeight) {
        header.classList.remove('js__header__stuck');
      } else if (currentScroll < lastScroll) {
        header.classList.add('js__header__stuck');
      } else {
        header.classList.remove('js__header__stuck');
      }
      
      lastScroll = currentScroll;
    });
  }

  // ============================================================
  // Variant Image Filtering
  // Filters product gallery to show only images matching the
  // selected Shopify variant OR Easify option.
  //
  // HOW TO TAG YOUR IMAGES IN SHOPIFY ADMIN:
  //
  // For Shopify native variants:
  //   Set the image alt text to:  variant--{option-value}
  //   Example: variant--Black   variant--White   variant--Blue
  //   (case-insensitive, spaces become hyphens automatically)
  //
  // For Easify app options:
  //   Set the image alt text to:  easify--{Option Name}--{Value}
  //   Example: easify--Frame Colour--Black
  //            easify--Frame Colour--White
  //            easify--Frame Colour--Natural Oak
  //
  // Images WITHOUT any variant-- or easify-- tag are always shown
  // (they are treated as shared/generic images for the product).
  // ============================================================

  const VARIANT_PREFIX = 'variant--';
  const EASIFY_PREFIX  = 'easify--';

  const activeFilters = { shopify: null, easify: {} };

  function normalise(str) {
    return (str || '').toLowerCase().trim().replace(/\s+/g, '-');
  }

  function isVisible(altText) {
    if (!altText) return true;
    const alt = altText.toLowerCase().trim();
    const isVariantTagged = alt.includes(VARIANT_PREFIX);
    const isEasifyTagged  = alt.includes(EASIFY_PREFIX);

    if (!isVariantTagged && !isEasifyTagged) return true;

    if (isVariantTagged && activeFilters.shopify) {
      // alt may be e.g. "variant--Black" or "variant--Natural Oak"
      const tagValue = alt.split(VARIANT_PREFIX)[1].trim();
      if (normalise(tagValue) === normalise(activeFilters.shopify)) return true;
    }

    if (isEasifyTagged) {
      const parts = alt.split('--');
      if (parts.length >= 3) {
        const optionName  = parts[1].trim();
        const optionValue = parts.slice(2).join('--').trim();
        const activeValue = activeFilters.easify[optionName];
        if (activeValue && normalise(activeValue) === normalise(optionValue)) return true;
      }
    }

    return false;
  }

  function applyImageFilter() {
    const hasAnyFilter = activeFilters.shopify || Object.keys(activeFilters.easify).length > 0;
    if (!hasAnyFilter) return;

    // Find all product image containers on the page
    document.querySelectorAll('product-images').forEach(function(gallery) {
      var section = gallery.closest('[data-section-id]');

      // --- Main slides ---
      var slides = gallery.querySelectorAll('[data-slide]');
      var firstVisible = null;

      slides.forEach(function(slide) {
        var img = slide.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '') : '';
        var show = isVisible(alt);
        slide.classList.toggle('variant-filtered--hidden', !show);
        if (show && !firstVisible) firstVisible = slide;
      });

      // Activate first visible slide
      if (firstVisible) {
        var mediaId = firstVisible.getAttribute('data-media-id');
        if (mediaId) {
          firstVisible.dispatchEvent(new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: { id: mediaId }
          }));
        }
      }

      // --- Thumbnails ---
      if (!section) return;
      var thumbs = section.querySelectorAll('product-thumbs [data-thumb-item]');
      thumbs.forEach(function(thumb) {
        var img = thumb.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '') : '';
        thumb.classList.toggle('variant-filtered--hidden', !isVisible(alt));
      });
    });
  }

  // ---- Hook into Broadcast theme's pub/sub variantChange ----
  // The theme uses a custom subscribe() global — wait for it to be ready
  function hookVariantChange() {
    if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        // Use ALL option values so any option position can be used for filtering
        activeFilters.shopify = variant.option1 || null;
        applyImageFilter();
      });
    } else {
      // Retry until theme pub/sub is available (it loads after custom.js)
      setTimeout(hookVariantChange, 100);
    }
  }
  hookVariantChange();

  // ---- Fallback: watch the selected-variant JSON script tag for changes ----
  // This catches variant changes even if pub/sub hook misses them
  function initVariantJsonWatcher() {
    document.querySelectorAll('[data-selected-variant]').forEach(function(el) {
      // Read initial variant on page load
      try {
        var variant = JSON.parse(el.textContent);
        if (variant && variant.option1) {
          activeFilters.shopify = variant.option1;
        }
      } catch(e) {}

      var observer = new MutationObserver(function() {
        try {
          var variant = JSON.parse(el.textContent);
          if (variant && variant.option1) {
            activeFilters.shopify = variant.option1;
            applyImageFilter();
          }
        } catch(e) {}
      });
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
    // Apply with initial shopify variant (Easify will apply its own on initEasifyWatchers)
    applyImageFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantJsonWatcher);
  } else {
    initVariantJsonWatcher();
  }


  // ---- Listen for Easify option changes ----
  // Easify uses React and updates a hidden input silently — no DOM change events fired.
  // We watch for:
  //   1. Value attribute changes on existing hidden inputs (po-optionHiddenInput-hiddenInput)
  //   2. New hidden inputs being added to the DOM (in case Easify renders them late)
  // The option name comes from: name="properties[Frame Colour]" → "Frame Colour"

  function extractEasifyOptionName(inputName) {
    // name="properties[Frame Colour]" → "frame colour"
    var match = (inputName || '').match(/^properties\[(.+)\]$/);
    return match ? match[1].toLowerCase().trim() : null;
  }

  function watchEasifyInput(input) {
    // Skip internal Easify tracking inputs (e.g. _tpo_add_by)
    var rawName = input.getAttribute('name') || '';
    var optionName = extractEasifyOptionName(rawName);
    if (!optionName || optionName.charAt(0) === '_') return;

    // Set initial filter value on page load
    var initialValue = input.value;
    if (initialValue) {
      activeFilters.easify[optionName] = initialValue;
    }

    // Watch for value changes via attribute mutation
    var observer = new MutationObserver(function() {
      var newValue = input.value;
      if (newValue) {
        activeFilters.easify[optionName] = newValue;
      } else {
        delete activeFilters.easify[optionName];
      }
      applyImageFilter();
    });
    observer.observe(input, { attributes: true, attributeFilter: ['value'] });

    // Also watch via a property descriptor override since React sets .value directly
    var originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (originalDescriptor && originalDescriptor.set) {
      var originalSet = originalDescriptor.set;
      var capturedOptionName = optionName;
      Object.defineProperty(input, 'value', {
        set: function(val) {
          originalSet.call(this, val);
          if (val) {
            activeFilters.easify[capturedOptionName] = val;
          } else {
            delete activeFilters.easify[capturedOptionName];
          }
          applyImageFilter();
        },
        get: function() {
          return originalDescriptor.get.call(this);
        },
        configurable: true
      });
    }
  }

  function initEasifyWatchers() {
    // Watch all current Easify hidden inputs
    document.querySelectorAll('input.po-optionHiddenInput-hiddenInput').forEach(watchEasifyInput);

    // Apply filter immediately with initial values already collected by watchEasifyInput
    applyImageFilter();

    // Watch for new Easify inputs added dynamically
    var domObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('input.po-optionHiddenInput-hiddenInput')) {
            watchEasifyInput(node);
            applyImageFilter();
          }
          node.querySelectorAll && node.querySelectorAll('input.po-optionHiddenInput-hiddenInput').forEach(function(input) {
            watchEasifyInput(input);
          });
          // If new inputs were found in descendants, apply filter once
          if (node.querySelectorAll && node.querySelectorAll('input.po-optionHiddenInput-hiddenInput').length > 0) {
            applyImageFilter();
          }
        });
      });
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Init after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEasifyWatchers);
  } else {
    initEasifyWatchers();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
